import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    callout:
      'This information is **mandatory** to open the pro Shine account of the company **{companyName}**.',
    capitalDepositDescription: `You have been invited by **{inviterName}** to add your credentials to their file to open the company's pro account **{companyName}** in the same manner as all beneficial owners and/or shareholders.`,
    cta: 'Start',
    heading: `Hello {beneficiaryName}`,
    list: [
      'Complete your personal information',
      'Add proof of identity (ID card, passport, residence permit)',
      'Verify your information',
    ],
    standardDescription: `You have been invited by **{inviteName}** to add your credentials to their file to open the pro account of company **{companyName}** along with all beneficial owners.`,
  },

  fr: {
    callout:
      'Ces informations sont **obligatoires** pour ouvrir le compte pro Shine de la société **{companyName}**.',
    capitalDepositDescription: `Vous avez été invité par **{inviterName}** à ajouter vos informations d’identité à son dossier pour ouvrir le compte pro de la société **{companyName}** au même titre que tous les bénéficiaires effectifs et/ou actionnaires.`,
    cta: 'Commencer',
    heading: `Bonjour {beneficiaryName}`,
    list: [
      'Compléter vos informations personnelles',
      'Ajouter un justificatif d’identité (CNI, passeport, titre de séjour)',
      'Vérification de vos informations',
    ],
    standardDescription:
      'Vous avez été invité par **{inviterName}** à ajouter vos informations d’identité à son dossier pour ouvrir le compte pro de la société **{companyName}** au même titre que tous les bénéficiaires effectifs.',
  },
} as const);

export default locales;
